module.exports = [
  ...require('./_gearRawList_w'),
  require('./war_pick'),
  require('./warhammer'),
  require('./whip'),
]
